import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import BapTrimCard from './BapTrimCard';
import InventoryTrimCard from './InventoryTrimCard';
export const TrimCardVariant = {
    Default: 'bap',
    Inventory: 'inventory',
};
const TrimCardMap = (props) => {
    const { variant } = props;
    switch (variant) {
        case TrimCardVariant.Inventory:
            return _jsx(InventoryTrimCard, { ...props });
        case TrimCardVariant.Default:
        default:
            return _jsx(BapTrimCard, { ...props });
    }
};
export default TrimCardMap;
